<template>
  <div style="text-align: justify">
    <h1 class="mb-4">Solubility Product - Prelab Exercise</h1>
    <p class="mb-5">
      a) Write the equilibrium expression for the dissolution of solid lead(II) iodide,
      <chemical-latex content="PbI2," />
      in water.
    </p>
    <p class="mb-5">
      b) Write the equation relating the solubility product,
      <stemble-latex content="$\text{K}_{\text{sp}},$" />
      for
      <chemical-latex content="PbI2" />
      to the solubility,
      <stemble-latex content="$\text{S,}$" />
      of the compound.
    </p>
    <p class="mb-3">
      c) <latex-number number="50.00" unit="\text{mL}" />
      of a standard solution of lead(II) iodide in water was passed through an ion-exchange resin
      (in the acid form). The protons released were collected and titrated against a standard
      solution of
      <latex-number :number="concNaOH" unit="\text{M}" />
      <chemical-latex content="NaOH\text{.}" />
      The endpoint of the titration occurred after the addition of
      <number-value :value="volTitration" unit="\text{mL}" />
      of
      <chemical-latex content="NaOH\text{.}" />
    </p>
    <p class="mb-3"><b>Calculate:</b></p>
    <p class="mb-3 pl-8">
      i) The molar solubility,
      <stemble-latex content="$\text{S,}$" />
      of
      <chemical-latex content="PbI2" />
    </p>

    <p class="mb-5 pl-8">
      ii) The value of the solubility product,
      <stemble-latex content="$\text{K}_{\text{sp}},$" />
      for lead(II) iodide.
    </p>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '../displayers/ChemicalLatex';
import LatexNumber from '../displayers/LatexNumber';
import NumberValue from '../NumberValue';

export default {
  name: 'UPEIKspPreLab2',
  components: {
    ChemicalLatex,
    StembleLatex,
    LatexNumber,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  computed: {
    volTitration() {
      return this.taskState.getValueBySymbol('volTitration').content;
    },
    Ksp() {
      // Back-end value is scaled by factor of 50
      return this.taskState.getValueBySymbol('Ksp').content;
    },
    concNaOH() {
      return (
        (Math.pow(this.Ksp.toFloat() / 50 / 4, 1 / 3) * 2 * 0.05 * 1000) /
        this.volTitration.toFloat()
      ).toFixed(6);
    },
  },
};
</script>
